import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Page not found", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "This page does not exist.", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    ($props.context && $props.context.site)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(" Site: " + _toDisplayString($props.context.site.name) + " ", 1),
          _hoisted_4,
          _createTextVNode(" Language: " + _toDisplayString($props.context.language), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}